import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import InputField from '../../../../../helpers/Fields/InputField';
import { required, email } from 'redux-form-validators'
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { createCardSubject, updateCardSubject } from '../../../../actions';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      hasPassoword: props.initialValues.password
    }
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose} = this.props;

      if(values.id){
        await this.props.updateCardSubject(values);
        toastr.success(formatMessage('msgNotificationTitleCardSubjectCreaded'), formatMessage('msgNotificationCardSubjectCreated'))

      } else {
        await this.props.createCardSubject(values);
        toastr.success(formatMessage('msgNotificationTitleCardSubjectUpdated'), formatMessage('msgNotificationCardSubjectUpdated'))
      }
      
      handleClose();
    } catch (error) {
    }
    
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, valuesForm } = this.props;
    if(!valuesForm){
      valuesForm = {};
    }
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='name'
          label={formatMessage('txtCaptionCardSubject')}
          component={InputField}
          validate={[required()]}
        />
        
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelCardSubject')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateCardSybject': 'btnModalUpdateCardSubject')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_subject',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_subject')(state)
})

const mapDispatchToProps = {
  createCardSubject,
  updateCardSubject,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/Subject/components/FormModal/FormContent.jsx